import { CommonModule } from '@angular/common';
import { Component, Input, inject, ViewEncapsulation } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
	selector: 'app-confirm-dialog',
	imports: [CommonModule, ConfirmDialogModule],
	templateUrl: './confirm-dialog.component.html',
	styleUrl: './confirm-dialog.component.scss',
	encapsulation: ViewEncapsulation.None,
})
export class ConfirmDialogComponent {
	@Input() key?: string; // Allows multiple confirm dialogs with different configurations

	/**
	 * Names the X of the confirmation dialog.
	 *
	 * `p-confirmDialog` accepts a `closeAriaLabel` but never forwards it to the
	 * `p-dialog` it wraps, so binding it does nothing; pass-through is the only
	 * handle on that button from outside PrimeNG. Plain dialogs are covered by
	 * DialogCloseLabelDirective, which cannot reach inside PrimeNG's own template.
	 */
	readonly pt = {
		pcCloseButton: { root: { 'aria-label': inject(TranslocoService).translate('common.actions.close') } },
	};
}
